module.exports = __webpack_public_path__ + "static/37255-67613b05de4c20273afcbe214bdd4794.jpg";